import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/9_2.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Lody"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p24,
            }}
            content={
                <div>
                    <ul>
                        <li>Spróbujmy lodów! – decydujesz.
                        </li>
                        <li>Świetny wybór – uśmiecha się Łukaszewski. – Szczęście, że mamy „Pikusia”  w Zagórowie! Trzyma dla nas lód w stodole od zeszłej zimy!</li>
                    </ul>
                    <p>
                        Kiedy karczmarz odchodzi, Emil dodaje:
                    </p>
                    <ul>
                        <li>Mówią, że klient nasz pan. Dlatego Łukaszewski ma prawie wszystko na słodko, według żydowskich przepisów.</li>
                        <li>Witam serdecznie śliwkowego króla! – przechodzący brodacz z pejsami wyciąga rękę, żeby przyjacielsko poklepać Emila po plecach, ale powstrzymuje ją, jak gdyby uznał, że nie jest z nim w wystarczająco zażyłych stosunkach. – Słyszałem, że pan Emil się dogadał na geszeft z Lejmerem? Może byście i mnie dowieźli, na weselnym stole śliwek nigdy za wiele, syn się żeni! – tutaj brodacz zawahał się, patrząc na ciebie.</li>
                        <li>Panie Garfunkel, zajedziemy jutro z samego rana! – odpowiada Emil, po czym dodaje: – Ale sam bym sadu nie obrobił… Niech pan pozna kogoś, kto mi w tym pomógł!</li>
                        <li>A, skoro to osoba zaufana… – teraz brodacz odwraca się w twoją stronę bez skrępowania.</li>
                        <li>Feliks Garfunkel, miło mi – przedstawia się, po czym wraca do omawiania szczegółów transakcji z Emilem. Po chwili macha wam na pożegnanie i wraca do swojego stołu, a wy zabieracie się do właśnie podanego deseru.</li>
                    </ul>
                </div>
            }
        />

    );
}